import React, { useEffect, useRef, useState } from 'react'
import GridList from '@material-ui/core/GridList'
import GridListTile from '@material-ui/core/GridListTile'
import { ArrowBackIosOutlined, ArrowForwardIosOutlined } from '@material-ui/icons'
import _ from 'lodash'

import './style.css'

const ScrollableList = (props) => {
  const { list, renderItem, extractKey } = props
  const scrollableEl = useRef(null)
  const [scrollX, setScrollX] = useState(0)
  const [scrollWindowWidth, setScrollWindowWidth] = useState(0)
  const [scrollWidth, setScrollWidth] = useState(0)

  const listenToScroll = _.debounce(() => {
    setScrollX(scrollableEl.current.scrollLeft)
    setScrollWidth(scrollableEl.current.scrollWidth)
  }, 100)

  const scrollTo = (element, to, duration) => {
    let start = element.scrollLeft,
        change = to - start,
        currentTime = 0,
        increment = 20

    const easeInOutQuad = (t, b, c, d) => {
      t /= d/2
      if (t < 1) return c/2*t*t + b
      t--
      return -c/2 * (t*(t-2) - 1) + b
    }
        
    const animateScroll = () => {        
        currentTime += increment
        var val = easeInOutQuad(currentTime, start, change, duration)
        element.scrollLeft = val
        if(currentTime < duration) {
            setTimeout(animateScroll, increment)
        }
    }
    animateScroll()
  }

  useEffect(() => {
    setScrollWindowWidth(scrollableEl.current.offsetWidth)
    setScrollWidth(scrollableEl.current.scrollWidth)
    scrollableEl.current.addEventListener('scroll', listenToScroll)

    return () => {
      scrollableEl.current.removeEventListener('scroll', listenToScroll)
    }
  }, [])

  const [width, setWidth] = useState(window.innerWidth);
  const [cols, setCols] = useState(
    width > 1920 ? 5.5 :
    width > 1440 ? 4.5 :
    width > 1280 ? 4 :
    width > 1100 ? 3.5 :
    width > 850 ? 3 :
    width > 620 ? 2.5 :
    width > 480 ? 2 :
    width > 400 ? 1.5 : 1
  )

  useEffect(() => {
    const handleResize = () => {
      setWidth(window.innerWidth);
      setCols(width > 1100 ? 3.5 :
        width > 850 ? 3 :
        width > 620 ? 2.5 :
        width > 480 ? 2 :
        width > 400 ? 1.5 : 1)
    }
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [width]);

  let listSize = 0
  if (Array.isArray(list)) {
    listSize = list.length
  } else {
    listSize = _.keys(list).length
  }

  return <div className='scrollable-container'>
    <GridList ref={scrollableEl} className='scrollable-list' cols={cols}>
      {
        scrollX > 0 &&
        <ArrowBackIosOutlined className='nav-arrow prev'
          onClick={() => scrollTo(scrollableEl.current, scrollableEl.current.scrollLeft - scrollWindowWidth, 1000)}
        />
      }
      {
        _.map(list, (item, idx) => (
          <GridListTile key={extractKey(item, idx)} className='list-item'>
            {renderItem(item)}
          </GridListTile>
        ))
      }
      {
        ((listSize > 3 && scrollX === 0) || (listSize > 3 && (scrollX + scrollWindowWidth) < scrollWidth)) &&
          <ArrowForwardIosOutlined className='nav-arrow next'
            onClick={() => scrollTo(scrollableEl.current, scrollableEl.current.scrollLeft + scrollWindowWidth, 1000)}
          />
      }
    </GridList>
  </div>
}
export default ScrollableList


// WEBPACK FOOTER //
// ./src/components/ScrollableList/index.js